// extracted by mini-css-extract-plugin
export default {"root":"TimeProgress_root__8Ey24","progressPath":"TimeProgress_progressPath__MwyAH","progressThumb":"TimeProgress_progressThumb__NxdzQ"};